import React from "react";
import { ButtonBase, ThemeProvider, theme } from "@reusejs/react";
import { XIcon } from "@heroicons/react/solid";

const newTheme = {
  ...theme,
  variants: {},
};

export default function ConfirmationModal(props: any) {
  return (
    <ThemeProvider value={newTheme}>
      <div className="relative shadow-sm flex flex-col">
        <div className="flex-1">
          <div
            className={
              "absolute z-50 -top-4 -right-4 rounded-full bg-gray-50 items-center px-2 py-2 border-b text-xs text-gray-900"
            }
          >
            <div
              className="cursor-pointer"
              onClick={() => props.onAction("no")}
            >
              <XIcon className="h-4 w-4" aria-hidden="true" />
            </div>
          </div>
          <div className={"relative border-b " + props.color}>
            <div className="px-4 lg:px-8">
              <div className="relative py-6 text-center">
                <h2 className="text-xl font-semibold tracking-tight">
                  {props.heading}
                </h2>
              </div>
            </div>
          </div>
          <div className="p-4 text-center max-w-lg">
            <div className="mt-2 min-h-max text-lg text-gray-500">
              {typeof props.description === "string" ? (
                <div dangerouslySetInnerHTML={{ __html: props.description }} />
              ) : (
                props.description
              )}
            </div>
          </div>

          <div className="flex justify-between items-center px-6 py-4 border-t">
            <ButtonBase
              variant="primary"
              type="button"
              label="Yes"
              onClick={() => {
                props.callback();
                props.onAction("no");
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-green-600 hover:bg-green-700",
                textColor: "text-white",
                border: "any",
                padding: "px-8 py-3",
              }}
            />
            <ButtonBase
              variant="primary"
              type="button"
              label="No"
              onClick={() => {
                props.onAction("no");
              }}
              buttonBaseClasses={{
                font: "text-sm font-medium",
                backgroundColor: "bg-red-600 hover:bg-red-700",
                textColor: "text-white",
                border: "any",
                padding: "px-8 py-3",
              }}
            />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
